// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContactForm_wrapper__MnA0i","form":"ContactForm_form__D6xVU"};